import React, { FC } from 'react';
import { ComponentConsumerProps, RichText, Text, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import CustomExternalAnchor from '../@shared/customExternalAnchor';
import { TKeepTouchProps } from './types/keepTouch.types';
import { KeepTouchModel } from './models/keepTouch.model';
import './styles.scss';
import Picture from '../@shared/picture';
import UnreleasedComponent from '../@shared/unreleasedComponent';
import { targetLinkdsk } from '../../utils/targetDskLink';
import useMediaQuery from '../../hooks/useMediaQuery';
import breakpoints from '../../constants/breakpoints.constants';
import ctaTypes from '../../enums/CTA.enums';

const KeepInTouch: FC< ComponentConsumerProps & TKeepTouchProps> = (props: TKeepTouchProps) => {
  const model = new KeepTouchModel(props);
  const isDesktop = useMediaQuery(`(min-width: ${breakpoints['tbl-p']}px)`);

  // Component is unreleased
  if (model.isUnreleased) {
    return <UnreleasedComponent />;
  }

  return (
    <>
      <div className="keep-touch-wrapper">
        <div className="keep-touch">
          <section className="keep-touch__keep-in-touch">
            {model.keepTitle && (
              <Text tag={model.headingTag} field={model.keepTitle} className="keep-touch__title keep-touch__title--keep-in-touch" />
            )}
            {model.keepContent && (
              <RichText tag="div" field={model.keepContent} className="keep-touch__content keep-touch__content--keep-in-touch rich-text color-inherit-link" />
            )}
            <CustomExternalAnchor
              field={model.keepLink}
              target={targetLinkdsk(model?.keepLink, isDesktop)}
              className={`${ctaTypes['baseButton']} ${ctaTypes['brandPrimary']} keep-touch__link`}
            />
          </section>
          <section className="keep-touch__need-support">
            <div className="keep-touch__need-support__bg-image-wrapper">
              <Picture
                editorialImageProps={{
                  desktopImage: model.desktopBgImage,
                  mobileImage: model.mobileBgImage,
                  desktopTransformation: 'Size1000',
                  mobileTransformation: 'Size1000',
                  cssClassImageEl: 'keep-touch__need-support__bg-image',
                }}
              />
            </div>
            <div className="keep-touch__need-support__content">
              {model.supportTitle && <Text tag={model.headingTag} field={model.supportTitle} className="keep-touch__title" />}
              {model.supportContent && <RichText tag="div" field={model.supportContent} className="keep-touch__content rich-text color-inherit-link" />}
              <CustomExternalAnchor
                field={model.supportLink}
                target={targetLinkdsk(model?.supportLink, isDesktop)}
                className={`${ctaTypes['baseButton']} ${ctaTypes['brandPrimary']} keep-touch__link`}
              />
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default withSitecoreContext()(KeepInTouch);
